import React from 'react';

import {isAdminPage, roundedElements} from 'Services/BaseHelpers';

import Base from './Base';

/**
 * @function DangerButton
 * @param {function} onClick
 * @param {string} className
 * @param {string} text
 * @param {boolean} working
 * @param {boolean} disabled
 * @param {string} [type]
 * @return {JSX.Element}
 * @constructor
 */
const DangerButton = ({ onClick, className, text, working, disabled, type }) => {
    let classes = `
        ${isAdminPage() ? 'bg-red-600 text-white' : 'bg-app-danger text-app-danger-contrast'}
        ${roundedElements() ? '' : ''}
        border border-transparent shadow-sm py-2 px-4
        inline-flex justify-center items-center text-sm font-medium
        leading-5 transition duration-150 ease-in-out
        ${
            !disabled && !working
                ? `
                    ${isAdminPage() ?
                        'hover:bg-red-800 focus:ring-red-500' :
                        'hover:bg-app-danger-hover focus:ring-app-danger-focus'}
                    focus:outline-none focus:ring-2 focus:ring-offset-2
                `
                : 'opacity-50'
        }
        ${className}
    `;

    if (!isAdminPage()) {
        // overwrite classes as required for non-admin pages.
    }

    return (
        <Base
            className={classes}
            type={type ?? (onClick !== undefined ? 'button' : 'submit')}
            onClick={onClick}
            disabled={disabled}
            working={working}
            text={text}
        />
    );
};

export default DangerButton;
